import React, { useState, useEffect } from "react";
import { StyleSheetManager } from "styled-components";
import UserInfo from "../api/UserInfo";
import isPropValid from "@emotion/is-prop-valid";
import CardTemplate from "../components/CardTemplate";

const UserProfile = () => {
  const [profileData, setProfileData] = useState({});
  const { getUserInfo } = UserInfo();
  useEffect(() => {
    getUserInfo().then(data => setProfileData(data));
  }, []);

  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <CardTemplate profileData={profileData} />
    </StyleSheetManager>
  );
};

export default UserProfile;
